<template>
  <div>
    <q-dialog v-model="alert">
      <q-card
        class="column "
        style="width: 300px; height:70vh; position: relative;"
      >
        <div class="section-box">
          <div class="title">
            <strong>{{ $t('result.orderStatus') }}</strong>
          </div>
          <ul class="section-ul">
            <li
              v-for="(item, index) in list"
              :key="index"
              :class="[item.status === cur ? 'cur' : '']"
            >
              <q-img
                v-if="item.status !== cur"
                src="~assets/images/Rectangle.png"
                class="Rectangle-icon"
              />
              <span v-if="item.status === cur" class="curricon" />
              <!-- <q-img
                v-if="item.status === cur"
                src="~assets/images/Rectangles.png"
                class="Rectangle-icon"
              /> -->
              <strong>{{ item.name }}</strong>
              <p>
                {{ item.time }}
              </p>
            </li>
          </ul>
        </div>

        <!--  OK 按钮 -->
        <div class="q-mt-lg checkDialog">
          <q-btn
            no-caps
            unelevated
            color="primary"
            class="border-radius-8 text-weight-bolder"
            label="OK"
            @click="closePopup"
          />
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { sellerTracking } from 'src/api/order.js';
import _ from 'lodash';

export default {
  data() {
    return {
      alert: false,
      cur: 0,
      list: [
        {
          // name: this.$t('order.statusName.100'), // 'Order dibuat',
          time: '',
          status: 100,
        },
        {
          // name: this.$t('order.statusName.200'), // 'Menunggu Pembayaran',
          time: '',
          status: 200,
        },
        {
          // name: this.$t('order.statusName.300'), // 'Pembayaran Berhasil',
          time: '',
          status: 300,
        },
        {
          // name: this.$t('order.statusName.400'), // 'Pesanan diterima',
          time: '',
          status: 400,
        },
        {
          // name: this.$t('order.statusName.500'), // 'Pesanan disiapkan',
          time: '',
          status: 500,
        },
        {
          // name: this.$t('order.statusName.600'), // ' Pesanan Siap',
          time: '',
          status: 600,
        },

        {
          // name: this.$t('order.statusName.610'), // 'Sedang mencari kurir',
          time: '',
          status: 610,
        },
        {
          // name: this.$t('order.statusName.620'), // ' Mendapatkan kurir',
          time: '',
          status: 620,
        },
        {
          // name: this.$t('order.statusName.630'), // 'Dalam perjalanan pengambilan',
          time: '',
          status: 630,
        },
        {
          // name: this.$t('order.statusName.700'), // 'Pengambilan berhasil',
          time: '',
          status: 700,
        },
        {
          // name: this.$t('order.statusName.800'), // 'Dalam Pengantaran',
          time: '',
          status: 800,
        },
        {
          // name: this.$t('order.statusName.900'), // 'Terkirim',
          time: '',
          status: 900,
        },
      ],
    };
  },
  watch: {
    alert: {
      handler(val) {
        if (val) {
          this.setList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$emit('setPopupChild', this);
  },
  methods: {
    closePopup() {
      this.alert = false;
    },
    setCur(val) {
      this.cur = val;
      if (this.isRiderError(val)) {
        this.cur = 610;
      }
    },
    setList() {
      // eslint-disable-next-line camelcase
      const { orderId, order_id } = this.$router.currentRoute.query;
      sellerTracking({
        // eslint-disable-next-line camelcase
        orderId: orderId || order_id
      }).then(res => {
        if (res?.code === 200) {
          const details = res?.data?.status || [];
          this.mergeList(details);
          const l = details.length;
          if (l > 0) {
            const r = details[l - 1];
            this.setCur(r.code);
          }
        }
      });
    },

    mergeList(list1 = []) {
      // 2种循环区别：n*n 和 n+n+x
      const hashData = {};
      list1.forEach(({ code, dateTime }) => {
        hashData[code] = dateTime;
      });
      this.list.forEach(data => {
        data.time = hashData[data.status];
        data.name = this.$t(`order.statusName.${data.status}`);
      });
      // _.forEach(list1, item1 => {
      //   _.forEach(list2, item2 => {
      //     if (item1.code === item2.status) {
      //       item2.time = item1.dateTime;
      //     }
      //   });
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.Rectangle-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  margin-top: -2px;
}
//
.section-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: 80px;
  box-sizing: border-box;
  text-overflow: auto;
  position: relative;
  border-radius: 4px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 25px;
}
//

.section-ul {
  padding: 0;
  margin: 0 30px;
  list-style: none;
  position: relative;
  li {
    list-style: none;
    margin: 15px 0 0 0;
    padding-left: 30px;
    position: relative;
    .Rectangle-icon,
    .curricon {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 4px;
      left: 7px;
    }
    .curricon {
      border: 4px solid $primary;
      border-radius: 10px;
    }
    strong {
      display: block;
      font-size: 12px;
      color: #9ca3af;
    }
    p {
      margin-top: 5px;
      color: #9ca3af;
      font-size: 12px;
    }

    &.cur {
      strong {
        color: $primary;
        font-size: 16px;
      }
      p {
        color: $primary;
        opacity: 0.8;
      }
      .Rectangle-icon {
        top: 5px;
      }
    }
  }
}

.deiver-box > div {
  color: #fff;
}

//  //  按钮样式
.checkDialog {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  height: 60px;
  text-align: center;
  .q-btn {
    width: 240px;
    height: 40px;
  }
}
</style>
